<div class="side-bar" id="nav-side" *ngIf="this.company">
  <div class="background-company" [ngStyle]="{'background-image': 'url('+ imgBg +')'}"></div>
  <div class="info-company">
    <div class="teste">
      <div [ngClass]="{'local-info': this.local, 'readOnly-info': this.readOnlyState}">

        <div class="img-company" (click)="this.openInfoCompany = true">
          <img class="img-company-image" [src]="imgLogo">
        </div>

        <ng-container *ngIf="!this.readOnlyState">

          <!--Loja temporariamente fechada-->
          <span *ngIf="!this.local && this.statusCompany && this.company.companyHours.online == 0" class="open-company" style="color: #bf7c00; background-color: #ffa5004d;">Loja temporariamente fechada</span>

          <!--Loja aberta-->
          <span *ngIf="!this.local && this.statusCompany && this.company.companyHours.online == 1" class="open-company" style="color: green; background-color: #0080002b; margin-top: 6px;">{{ textStatusCompany }}</span>

          <!--Loja fechada-->
          <span *ngIf="!this.local && !this.statusCompany" class="open-company" style="color: #d70000; background-color: #ff000040;">{{ textStatusCompany }}</span>

          <!--Disponível para agendamento-->
          <span *ngIf="!this.local && this.company.configs.closeScheduling == 1" class="open-company" style="color: green; background-color: #0080002b; margin-top: 6px;">Disponível para agendamento</span>
          
        </ng-container>
        
        <!--Visivel se não estiver em modo Readonly-->
        <ng-container *ngIf="!this.readOnlyState">

          <!--Visivel se não for mesa ou comanda-->
          <div class="infos" *ngIf="!this.local">

            <!--Pedido Minimo-->
            <div class="info-chip" *ngIf="this.company.configs.minValue != 0">
              <span class="chip-label">Mínimo</span>
              <span class="chip-value">{{ this.company.configs.minValue | currency: 'BRL' }}</span>
            </div>

            <!--Status da loja-->
            <div class="info-chip" *ngIf="!this.statusCompany && this.company.companyHours.dataOpen">
                <span class="chip-label">Abre às</span>
                <span class="chip-value">{{ this.company.companyHours.dataOpen | timeFormat }}</span>
            </div>

            <div class="info-chip" *ngIf="this.statusCompany && this.company.companyHours.dataClose">
              <span class="chip-label">Fecha às</span>
              <span class="chip-value">{{ this.company.companyHours.dataClose | timeFormat }}</span>
            </div>

            <!--Tempo de preparo Delivery-->
            <ng-container *ngIf="!this.localCounter">
              <div class="info-chip" *ngIf="this.timesInfo.delivery.active">
                <span class="chip-label">Entrega</span>
                <span class="chip-value">{{ this.timesInfo.delivery.label }}</span>
              </div>
            </ng-container>

            <!--Tempo de preparo Balcão-->
            <ng-container *ngIf="this.localCounter">
              <div class="info-chip" *ngIf="this.timesInfo.counter.active">
                <span class="chip-label">Retirada</span>
                <span class="chip-value">{{ this.timesInfo.counter.label }}</span>
              </div>
            </ng-container>
          </div>

          <div class="infos"  *ngIf="this.local">
            <span style="font-weight: 600; color: var(--primary-color);" *ngIf="this.typeParam.type == 1">MESA {{ this.typeParam.numberParam }}</span>
            <span style="font-weight: 600; color: var(--primary-color);" *ngIf="this.typeParam.type == 2">COMANDA {{ this.typeParam.numberParam }}</span>
          </div>

        </ng-container>

        <!--Button info company-->
        <div class="icons-info" style="left: 0px;" (click)="openInfoCompany = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
        </div>
        
        <!--Button share-->
        <div class="icons-info" style="right: 0px;" (click)="share()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2-icon lucide-share-2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>
        </div> 
      </div>
    </div>

  </div>

  <div class="menu-side-bar" [ngClass]="{'local': this.local, 'readOnly': this.readOnlyState}">
      <ul>
        <ng-container *ngFor="let category of tabela; let i = index">
          <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">
            <li>
              <a class="links-navegation" (click)="clicked = true; colorBarClick($event, i);" #meulink>{{ category.categoryName }} <i class="fa-solid fa-chevron-right chevron-side active"></i></a>
            </li>
          </ng-container>
        </ng-container>
      </ul>
  </div>
</div>

<app-info-company [openInfo]="this.openInfoCompany" (closeInfo)="this.openInfoCompany = false; this.scrollService.enableScroll()"></app-info-company>
